// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "af1299b39b5e156104b44593998251da992bfa17/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};